export const storageToken = "_moversly_web_access_token";
export const storageShipment = "_moversly_shipment";
export const refreshToken = "_moversly_web_refresh_token";
